import useAxiosCall from './useAxiosCall';
import { useNotification } from '../Context/NotificationContext';
import { decryptData, encryptData } from '../Utilities/CryptoUtility';
import { SecureStorage } from '../Utilities/StorageEncryption';
const useNotifications = () => {
    const { makeApiCall } = useAxiosCall();
    const { notifications, setNotifications, notificationsFetch, setNotificationsFetch, notificationsCount, setNotificationsCount} = useNotification();

    const handleApiCallSuccess = (data, page) => {
        let decryptedData = decryptData(data.data);
        if (page == 1) {
            setNotifications(decryptedData.notifications.data)
        } else {
            setNotifications(notifications.concat(decryptedData.notifications.data));
        }    
        if (decryptedData.notifications.to == decryptedData.notifications.total || decryptedData.notifications.data.length == 0) {
            setNotificationsFetch(false)
        }
    };

    const handleApiCallError = (errorMessage) => {
        console.log(errorMessage);
    };

    const fetchNotifications = async (page=1, force = false) => {
        if (notificationsFetch == true || force == true ) {
            try {
                const requestData = {
                    data: encryptData(JSON.stringify(
                        {
                            domain: SecureStorage.getItem('domain'),
                            page:page
                        }
                    ))
                };

                await makeApiCall({
                    requestData,
                    url: 'getNotifications',
                    requestType: 'POST',
                    onSuccess: (data) => handleApiCallSuccess(data, page),
                    onError: handleApiCallError,
                    loader:false
                });

            } catch (error) {
                console.error('Error fetching notifications:', error);;
            }
        }
    };

    return { fetchNotifications };
};

export default useNotifications;
